import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Gift, MessageCircle, Calendar, Sparkles, Check } from 'lucide-react';
interface Bonus {
  id: number;
  title: string;
  subtitle: string;
  value: string;
  description: string;
  benefits: string[];
  image: string;
  color: 'teal' | 'coral' | 'yellow';
}
const bonuses: Bonus[] = [{
  id: 1,
  title: 'Kit "Frases Anti-Berrinche"',
  subtitle: 'Bono #1 (GRATIS)',
  value: '$15.89',
  description: 'Guiones listos (de 10 segundos) para los momentos donde normalmente terminas gritando o negociando.',
  benefits: ['Saber qué decir cuando tu hijo se niega, grita o se tira al piso', 'Poner límites sin entrar en discusión', 'Volver al sistema rápido cuando el día se desordena'],
  image: 'https://cdn.magicpatterns.com/uploads/rAXJR4onxP682dgqe1keps/Bono_1.png',
  color: 'teal'
}, {
  id: 2,
  title: 'Planner "Mañana en Calma" (7 días)',
  subtitle: 'Bono #2 (GRATIS)',
  value: '$15.89',
  description: 'Un plan simple para ordenar tus mañanas sin abrumarte: qué preparar, qué simplificar y cómo sostenerlo por una semana completa.',
  benefits: ['Dejar lista la mañana en pocos minutos (sin improvisar)', 'Instalar el hábito con un plan de 7 días', 'Tener una "rutina mínima" para días difíciles'],
  image: 'https://cdn.magicpatterns.com/uploads/42g7hVtv1ypRUDAPGu5QF8/Bono2.png',
  color: 'coral'
}, {
  id: 3,
  title: 'Pack "Personaliza en 5 Min"',
  subtitle: 'Bono #3 (GRATIS)',
  value: '$15.89',
  description: 'Plantillas y recursos para personalizar el sistema con el nombre de tu hijo y lograr que se enganche más rápido (sin complicarte).',
  benefits: ['Hacer que tu hijo lo sienta suyo desde el día 1', 'Evitar peleas con elecciones limitadas (sin perder autoridad)', 'Aumentar cooperación sin sobornos'],
  image: 'https://cdn.magicpatterns.com/uploads/oTb3k9tDjAG9iVXQEAkGpm/Bono3.png',
  color: 'yellow'
}];
const colorStyles = {
  teal: {
    bg: 'bg-gradient-to-br from-[#E6F4F4] to-[#D4EFED]',
    border: 'border-[#4AAAA5]/20',
    badge: 'bg-[#4AAAA5]',
    icon: 'text-[#4AAAA5]',
    iconBg: 'bg-[#4AAAA5]/10'
  },
  coral: {
    bg: 'bg-gradient-to-br from-[#FFF5E6] to-[#FFEDD5]',
    border: 'border-[#E8845F]/20',
    badge: 'bg-[#E8845F]',
    icon: 'text-[#E8845F]',
    iconBg: 'bg-[#E8845F]/10'
  },
  yellow: {
    bg: 'bg-gradient-to-br from-[#FFFDF5] to-[#FFF9E6]',
    border: 'border-[#F5C842]/30',
    badge: 'bg-[#F5C842]',
    icon: 'text-[#D4A72C]',
    iconBg: 'bg-[#F5C842]/20'
  }
};
const BonusIcon = ({
  color
}: {
  color: 'teal' | 'coral' | 'yellow';
}) => {
  const icons = {
    teal: <MessageCircle className="w-5 h-5" data-id="element-88" />,
    coral: <Calendar className="w-5 h-5" data-id="element-89" />,
    yellow: <Sparkles className="w-5 h-5" data-id="element-90" />
  };
  return icons[color];
};
export function Bonuses() {
  return <Section background="white" className="relative overflow-hidden" data-id="element-91">
      {/* Background decoration */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-[#4AAAA5] opacity-5 rounded-full blur-3xl" data-id="element-92"></div>
      <div className="absolute bottom-20 left-10 w-64 h-64 bg-[#E8845F] opacity-5 rounded-full blur-3xl" data-id="element-93"></div>

      {/* Header */}
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-94">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-[#E8845F] to-[#F5A574] text-white font-bold text-sm mb-5" data-id="element-95">
          Valor total: $47 — Hoy: GRATIS
        </div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-4" data-id="element-96">
          Hoy te llevas 3 bonos GRATIS
        </h2>
        <p className="text-gray-600 text-lg leading-relaxed" data-id="element-97">
          No solo compras el kit imprimible. Te llevas un sistema completo para
          que realmente lo implementes y se sostenga.
        </p>
      </div>

      {/* Bonuses Grid */}
      <div className="space-y-8 max-w-5xl mx-auto" data-id="element-98">
        {bonuses.map(bonus => {
        const styles = colorStyles[bonus.color];
        return <div key={bonus.id} className={`${styles.bg} rounded-3xl border-2 ${styles.border} overflow-hidden`} data-id="element-99">
              <div className="grid md:grid-cols-2 gap-6 p-6 md:p-8 items-center" data-id="element-100">
                {/* Image */}
                <div className="order-1 md:order-1" data-id="element-101">
                  <div className="relative" data-id="element-102">
                    <img src={bonus.image} alt={bonus.title} className="w-full max-w-xs mx-auto rounded-2xl shadow-lg" data-id="element-103" />
                    {/* Free badge */}
                    <div className={`absolute -top-3 -right-3 ${styles.badge} text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-md`} data-id="element-104">
                      GRATIS
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="order-2 md:order-2" data-id="element-105">
                  {/* Subtitle with icon */}
                  <div className="flex items-center gap-2 mb-3" data-id="element-106">
                    <div className={`w-8 h-8 rounded-full ${styles.iconBg} flex items-center justify-center`} data-id="element-107">
                      <Gift className={`w-4 h-4 ${styles.icon}`} data-id="element-108" />
                    </div>
                    <span className={`text-sm font-bold ${styles.icon} uppercase tracking-wide`} data-id="element-109">
                      {bonus.subtitle}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-extrabold text-gray-800 mb-2" data-id="element-110">
                    {bonus.title}
                  </h3>

                  {/* Value */}
                  <p className="text-sm text-gray-500 mb-4" data-id="element-111">
                    <span className="line-through" data-id="element-112">Valor: {bonus.value}</span>
                    <span className={`ml-2 font-bold ${styles.icon}`} data-id="element-113">
                      — Hoy: $0
                    </span>
                  </p>

                  {/* Description */}
                  <p className="text-gray-600 mb-5 leading-relaxed" data-id="element-114">
                    {bonus.description}
                  </p>

                  {/* Benefits */}
                  <div className="space-y-3" data-id="element-115">
                    <p className="text-sm font-bold text-gray-700" data-id="element-116">
                      Te ayuda a:
                    </p>
                    {bonus.benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-117">
                        <div className={`w-5 h-5 rounded-full ${styles.badge} flex items-center justify-center flex-shrink-0 mt-0.5`} data-id="element-118">
                          <Check className="w-3 h-3 text-white" data-id="element-119" />
                        </div>
                        <span className="text-gray-700 text-sm" data-id="element-120">{benefit}</span>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>

      {/* Closing section */}
      <div className="mt-12 max-w-3xl mx-auto" data-id="element-121">
        <div className="bg-gradient-to-r from-[#FFFDF5] to-[#FFF9E6] rounded-2xl p-6 md:p-8 border-2 border-[#F5C842]/30 text-center" data-id="element-122">
          <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-123">
            <span className="font-bold" data-id="element-124">En resumen:</span> compras el Kit
            Imprimible… y hoy te llevas estos 3 bonos gratis para que no tengas
            que adivinar, improvisar ni sostener todo "a fuerza de voz".
          </p>
          <p className="text-sm text-gray-500 mb-6" data-id="element-125">
            Descarga inmediata + bonos incluidos por tiempo limitado.
          </p>
          <Button size="lg" withIcon onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-126">
            Quiero el Kit + Bonos
          </Button>
        </div>
      </div>
    </Section>;
}